export function createPagination(currentPage, total, perPage, totalPages) {
    return {
        currentPage,
        perPage,
        total,
        totalPages,
    };
}
